import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { PACompoundDetail } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        Carrier: '',
        MemberID: '',
        Account: '',
        Group: '',
        PANumber: '',
        ProductCode: '',
        ProductName: '',
        CostType: '',
        CostValue: '',
        MACList: '',
        CostSource: '',
        QL: '',
        PartB: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "Carrier",
        collectionName: "PA CompoundDetail"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        Account: false,
        Group: false,
        MemberID: false,
        Carrier: false,
        PANumber: false,
    }
}

export const getPACompoundDetailData = createAsyncThunk('data/getPACompoundDetailData',
    async (data, { rejectWithValue }) => {
        try {
            let queryPACompound =
                `query GetPriorAuthCompoundDetails{
                    GetPriorAuthCompoundDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"PA CompoundDetail",
                isDownload:false,
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.MemberID ? `,memberid: "${data.MemberID}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.PANumber ? `,panumber: "${data.PANumber}"` : ""}
                `;

            queryPACompound += PACompoundDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPACompound, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getPACompoundDetailDataDownloadAll = createAsyncThunk('data/getPACompoundDetailDataDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryPACompoundAll =
                `query GetPriorAuthCompoundDetails{
                    GetPriorAuthCompoundDetails(
                    collectionName:"PA CompoundDetail",
                    isDownload:true,
                    ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                    ${data.MemberID ? `,memberid: "${data.MemberID}"` : ""}
                    ${data.Account ? `,account: "${data.Account}"` : ""}
                    ${data.Group ? `,group: "${data.Group}"` : ""}
                    ${data.PANumber ? `,panumber: "${data.PANumber}"` : ""}
                        `;

            queryPACompoundAll += PACompoundDetail

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryPACompoundAll, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const paCompoundDetailSlice = createSlice({
    name: 'paCompound',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPACompoundDetailData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getPACompoundDetailData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetPriorAuthCompoundDetails.totalCount;
                state.data.tableData = response.data.data.GetPriorAuthCompoundDetails.data;
            })
            .addCase(getPACompoundDetailData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getPACompoundDetailDataDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getPACompoundDetailDataDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.tableData = response.data.data.GetPriorAuthCompoundDetails.data;
            })
            .addCase(getPACompoundDetailDataDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = paCompoundDetailSlice.actions;
export default paCompoundDetailSlice.reducer